import React, { Component } from 'react';
import { Link } from 'react-router-dom';

export default class ApiDocsBreadCrumbs extends Component {

  render() {
    return (
      <nav>
        <div className="breadcrumbs">
          <div className="breadcrumb">
            <Link to="/">Home</Link>
          </div>
          <div className="breadcrumb">
            <span>API Docs</span>
          </div>
        </div>
      </nav>
    )
  }
}
